export default __webpack_public_path__ + "static/86f448ce08f762dfc306233bc77f6f91.jpg";